module.exports = __webpack_public_path__ + "img/thumnail4.26174dc1.jpg";